import Image from '@Components/image';
import React, { useState, useRef } from 'react';
import ImageIllustrations from './Illustrations/Image/Image';
import { IMaalrettetMeddelelse, TIllustration } from './MaalrettetMeddelelse.definition';
import SlideInText from './SlideInText';
import ScrollIcon from '@Components/ServiceTjek/ScrollIkon';
import { useIsMounted } from '../../../hooks/useIsMounted';

const renderIllustration = (illustration: TIllustration, isPDF = false) => {
	const { illustrationType, text } = illustration;

	switch (illustrationType) {
	case 'image': {
		const { url, alt } = illustration.billede;

		if (isPDF) {
			return <Image src={ url } alt={ alt } ratio="custom" />;
		}

		return <ImageIllustrations url={ url } alt={ alt } text={ text } />;
	}
	case 'barchart':
		return 'got barchart';

	default:
		return 'no illustration';
	}

};

const MaalrettetMeddelelse = ({ reverse, text, overskrift, infoText, illustration, knapText, nummer, id, isPDF = false }: IMaalrettetMeddelelse) => {
	const [visMeddelelse, setVisMeddelelse] = useState(false);
	const isMounted = useIsMounted();
	const domRef = useRef(null);
	const nextIsSection = domRef?.current?.nextSibling?.tagName === 'SECTION';

	const toggleVisMeddelelse = () => setVisMeddelelse(!visMeddelelse);

	const renderText = () => (
		<div className="text-content" id={ id } >
			{ overskrift && <h3 className="text-lg font-semibold responsive">{ overskrift }</h3> }
			{ text && <div className="text-sm mb-3 responsive" dangerouslySetInnerHTML={ { __html: text } } /> }
			{ !isPDF && infoText && <button className="button button--liv" onClick={ toggleVisMeddelelse }>{ knapText || 'Vores Anbefalinger' }</button> }
			{ isPDF && (
				<>
					<div className="page-break" />
					<div dangerouslySetInnerHTML={ { __html: infoText } } />
				</>
			) }
		</div>
	);

	const renderPdfVersion = () => (
		<section className="f-grid" ref={ domRef }>
			<div className="col-sm-12 col-md-6 col-md-shift-3 col-lg-6 col-lg-shift-3 mb-3">
				{ illustration && renderIllustration(illustration, true) }
			</div>
			{ renderText() }
		</section>
	);

	if (isPDF) {
		return (
			<>
				{ renderPdfVersion() }
			</>
		);
	}

	return (
		<section className="servicetjek-maalrettet-meddelelse" ref={ domRef }>
			<div className="f-grid">
				<div className={ ['col-sm-6 col-md-5 col-lg-5 align-items-center d-flex', reverse ? 'reverse col-sm-shift-0 col-md-shift-1 col-lg-shift-1' : ''].join(' ') }>
					{ renderText() }
				</div>
				<div className={ ['col-sm-6 col-md-6 col-lg-6', reverse ? '' : 'col-sm-shift-0 col-md-shift-1 col-lg-shift-1'].join(' ') }>
					<div className={ reverse ? 'd-flex justify-content-center' : 'd-flex justify-content-center' }>
						{ illustration && renderIllustration(illustration) }
					</div>
				</div>
			</div>
			<SlideInText onClose={ toggleVisMeddelelse } show={ visMeddelelse } text={ infoText } slideInFromLeft={ reverse } />

			{ isMounted && nextIsSection && <ScrollIcon id={ 'pil_0' + (nummer).toString() + '0_dim2' } scrollToEl={ domRef.current.nextSibling } /> }
		</section>
	);
};

export default MaalrettetMeddelelse;
